module.exports = __webpack_public_path__ + "img/Jessica.6cb4ccf.png";